var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedImagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 719.4 597.5",
    style: {
      enableBackground: "new 0 0 719.4 597.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481,59.8L481,59.8C440.4,20,391.3,0,333.8,0c-57.5,0-106.6,20-147.3,59.8v0c-20.5,20.2-35.9,42.4-46.1,66.8 c-9.8,23.3-14.8,48.6-15.1,75.7c-25.1,9.4-47.9,24.4-68.3,44.9C19,285.1,0,330.9,0,384.5c0,53.6,19,99.4,56.9,137.3 c37.9,37.9,83.7,56.9,137.3,56.9c21.2,0,41.2-3,60-9c31.3,18.4,66.6,27.7,105.7,27.7c40.2,0,76.3-9.8,108.2-29.2v1.2 c17.2,4.7,35.3,7,54.4,7c54.3,0,100.6-18.9,139-56.5v0c38.6-37.8,57.9-83.4,57.8-137c0-53.5-19.3-99.2-57.8-137.1 c-24.2-23.7-51.5-40-82-48.8c-3-0.8-6-1.6-9.1-2.4c-9.3-2.2-18.8-3.7-28.7-4.5c-1.5-22.6-6.3-43.8-14.7-63.7 C516.9,102.2,501.5,80,481,59.8 M441,100.6c8.4,8.2,15.5,16.9,21.5,26c15.1,23.1,22.6,49.2,22.7,78.4c0,11.1-1.1,21.8-3.3,32 c-0.3,0.6-1,3-2.2,7.4c-1.2,4.2-1.8,6.5-1.9,7.1c0,0.3-0.1,0.6-0.2,0.9c14.1-4.5,29.1-6.8,45-6.8c36.6,0,68.1,11.9,94.6,35.6 c1.7,1.5,3.5,3.1,5.1,4.8c27.3,26.8,41,59.2,41.1,97.1c0,37.9-13.7,70.2-41.1,97h0c-27.4,26.9-60.5,40.4-99.3,40.5 c-17.4-0.5-34.3-5.7-50.6-15.8c-43.1,30.7-79.5,44.4-109.2,40.9c-29.7-3.4-56.7-11.7-81.1-24.8l-28.7-13.1 c-12.6,8.4-30.6,13-54.1,14l-0.6,0.9c-1.5,0-2.9,0-4.4,0.1c-38.2,0-70.8-13.5-97.8-40.5c-27-27-40.5-59.5-40.5-97.7 c0-38.2,13.5-70.8,40.5-97.8c25.7-25.6,56.4-39.1,92.2-40.3c-1-4.6-2.1-9.8-3.1-15.6c-2.1-11.5-3.2-20.1-3.2-25.9 c0-29.2,7.6-55.3,22.6-78.4c6-9.2,13.1-17.8,21.5-26h0.1c29.6-29,65.3-43.5,107.2-43.5C375.7,57,411.4,71.5,441,100.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedImagesIcon);
export default __webpack_public_path__ + "static/media/uploaded_images_icon.07769912.svg";
export { ForwardRef as ReactComponent };